<div class="modalContainer">
    <div class="header">
        <img src="../../../../../assets/gif/finzy-flex/investment-reversal.svg" alt="investment reversal image"
            class="modal-image" />
        <div class="modal-title">Are you sure?</div>
    </div>

    <div class="modal-body">
        <span>By clicking on <strong style="color: #000;"> Reverse </strong> your investment allocation to this loan will be
            <strong style="color: #000;"> deallocated </strong></span>
    </div>

    <div class="modal-footer">
        <button type="button" mat-stroked-button class="primary no-text-transform"
            [mat-dialog-close]="false">Back</button>

        <button type="button" mat-flat-button class="primary no-text-transform continue-button"
            [mat-dialog-close]="true" cdkFocusInitial>Reverse</button>
    </div>
</div>